/**
 * 线下培训班级学员列表功能
 * @Author:wuTao
 * @Date 2020/3/6
 */
import React from 'react';
import {connect} from 'dva';
import {reduxTemplateConfig, templateConfig} from './config';

import {component_tool, framework_tool, utils_tool} from '@/tool'
import {WizModalUserIdentityShow} from '@/containers/common';
import StudentCommentDetail from "./studentCommentDetail";

let {checkStrLength, Session} = utils_tool;
let {WizSpin, WizBrowserExport, WizModal} = component_tool;
let {WizContainer, WizReduxTemplate, modelUtils} = framework_tool;


const getTrainPathComment = (history) => {
  let record = {}
  if (history.location) {
    if (history.location.pathname === '/comment/trainPathCommentAudit') {
      if (history.location && history.location.record) {
        record = history.location.record;
        Session.set('trainPathCommentRecordInfo', record)
      } else {
        record = Session.get('trainPathCommentRecordInfo') || 0
      }
    }
  } else {
    record = Session.get('trainPathCommentRecordInfo') || 0
  }
  return record
}

class StudentCommentAudit extends WizContainer {

  componentName = 'studentCommentAudit';

  constructor(props) {
    super(props);
    const {history} = props;
    this.state = {
      studentCommentRecord: {},
      showUserPersonInfoVisible: false,
      showCommentVisible: false,
      studentCommentModalKey:new Date().getTime(),
      batchAuditVisible: false,
      selectedStudentCommentRows: [],//选择的学员评语
      selectedRows: 0
    };
    this.initialValue = getTrainPathComment(props.history);
  }

  /**
   * 页面动作操作后进行提示
   * @param nextProps
   * @param nextState
   * @param key
   * @returns {boolean}
   * @private
   */
  _handleStudentComment(nextProps, nextState, key) {
    let o = nextProps[key];
    if (o['success']) {
      wizNotice.success(o['msg']);
      return true;
    } else {
      wizNotice.error(o['msg']);
      return false;
    }
  }

  _handleFile(nextProps, nextState, key) {
    let o = nextProps[key]
    let columnDefs = [
      {
        headerName: '',
        width: 30,
        field: 'rowIndex',
        hidden: true,
        suppressMovable: true,
        cellStyle: {
          textAlign: 'center',
          padding: '5px 0',
          color: '#595959',
          backgroundColor: '#f0f0f0',
          display: 'inline-flex',
          alignItems: 'center',
          justifyContent: 'center',
          fontWeight: '500',
          boxShadow: '0 2px 0px 0 rgba(0,0,0,0.15)',
        },
      },
      {
        headerName: '姓名',
        field: 'fullName',
        width: 20,
        cellStyle: {
          textAlign: 'center',
        },
        style: {
          alignment: { vertical: 'bottom', horizontal: 'center' },
        },
      },
      {
        headerName: '账号',
        field: 'userName',
        width: 15,
        cellStyle: {
          textAlign: 'center',
        },
        style: {
          alignment: { vertical: 'bottom', horizontal: 'center' },
        },
      },
      {
        headerName: '手机号',
        field: 'mobile',
        width: 15,
        cellStyle: {
          textAlign: 'center',
        },
        style: {
          alignment: { vertical: 'bottom', horizontal: 'center' },
        },
      },
      /* {
        headerName: '证件号码',
        field: 'idCard',
        width: 25,
        cellStyle: {
          textAlign: 'center',
        },
        style: {
          alignment: { vertical: 'bottom', horizontal: 'center' },
        },
      }, */
      {
        headerName: '任职',
        field: 'userIdentityInfos',
        width: 50,
        cellStyle: {
          textAlign: 'center',
        },
        style: {
          alignment: { vertical: 'bottom', horizontal: 'center' },
        },
      },
      {
        headerName: '评语状态',
        field: 'stateStr',
        width: 20,
        cellStyle: {
          textAlign: 'center',
        },
        style: {
          alignment: { vertical: 'bottom', horizontal: 'center' },
        },
      },
      {
        headerName: '提交时间',
        field: 'submitTime',
        width: 20,
        cellStyle: {
          textAlign: 'center',
        },
        style: {
          alignment: { vertical: 'bottom', horizontal: 'center' },
        },
      },
      {
        headerName: '审核时间',
        field: 'auditTime',
        width: 20,
        cellStyle: {
          textAlign: 'center',
        },
        style: {
          alignment: { vertical: 'bottom', horizontal: 'center' },
        },
      }

    ]
    if (o['success']) {
      let data = o['data']
      let data_ = [];
      data.forEach(element => {
        switch( element.state){
          case 1 : element.stateStr = "待审核"
           break;
          case 2 : element.stateStr = "已通过"
           break;
          case 3 : element.stateStr = "驳回"
           break;
        }
        data_.push(element);
      });
      WizBrowserExport({
        title: '评语审核信息',
        sheetName: '评语审核信息',
        columns: columnDefs.filter((_, index) => index),
        rows: data_,
        filename: '评语审核信息.xlsx',
      })
      // wizNotice.success(o['msg'])
      return true;
    } else {
      wizNotice.error(o['msg'])
      return false;
    }
  }

  _render() {
    //初始化路径评语ID
    const {showUserPersonInfoVisible, showCommentVisible, studentCommentRecord} = this.state;
    let initialValue = this.initialValue;
    const {id, name} = initialValue;
    let _templateConfig = templateConfig({
      onSelect: (keys, rows) => {
        this.setState({
          selectedStudentCommentRows: rows,
          selectedRows: rows.length
        });
      },
      _this: this,
      pathCommentId: id, pathCommentName: name,
      _btnLookUserFun: (e) => {
        if (e.record) {
          this.setState({
            studentCommentRecord: e.record,
            showUserPersonInfoVisible: true,
          })
        }
      },
      _btnLookCommentFun: (e) => {
        if (e.record) {
          this.setState({
            studentCommentRecord: e.record,
            showCommentVisible: true,
            studentCommentModalKey:new Date().getTime(),
          })
        }
      }
    });
    let _reduxTemplateConfig = reduxTemplateConfig({
      pathCommentId: id,
      templateConfig: _templateConfig,
      apiDataFormat: {
        batchAudit: this._handleClassStudent,
        export:this._handleFile
      },
    });
    let lookUserPersonInfoModal = {
      title: '查看任职',
      visible: showUserPersonInfoVisible,
      personId: studentCommentRecord.personId ? studentCommentRecord.personId : null,
      orgId: null,
      positionId: null,
      onCancel: (e) => {
        this.setState({
          showUserPersonInfoVisible: false,
          studentCommentRecord: {},
        });
      },
    };
    let lookStudentCommentDetailModal = {
      title: '查看评语',
      visible: showCommentVisible,
      footer: null,
      width: 850,
      onCancel: (e) => {
        this.setState({
          showCommentVisible: false,
          studentCommentRecord: {},
        });
      },
    }
    let studentOther = {record: studentCommentRecord}
    return (
      <>
        <WizReduxTemplate {..._reduxTemplateConfig} />
        <WizModalUserIdentityShow {...lookUserPersonInfoModal}/>
        <WizModal key={'lookCommentDetail'+this.state.studentCommentModalKey} {...lookStudentCommentDetailModal}>
          <StudentCommentDetail {...studentOther}/>
        </WizModal>
      </>)
  }
}

const mapStateToProps = (state, ownProps) => {
  return {}
};

export default connect(mapStateToProps)(StudentCommentAudit);
